import { render, staticRenderFns } from "./LeadForwardingAnalytics.vue?vue&type=template&id=198957e2&scoped=true&"
import script from "./LeadForwardingAnalytics.vue?vue&type=script&lang=js&"
export * from "./LeadForwardingAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198957e2",
  null
  
)

export default component.exports